import React, {useState} from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'
import formatCurrency from '../../../utils'
import { Label } from '../../JurosCompostos/Label'

export const Table = (props) => {
  
    function calcularRentabilidadeReal(taxa, inflacao){
      return ((1 + taxa)/(1+inflacao)-1)*100
    }

    function criaTabela(){
      let investido = props.investido
      let acumulado = Object.assign([], props.acumulado)
      let table = []
      let columns = []
      for (let coluna = 0; coluna < acumulado.length; coluna++) {
        let row = []
        // Adiciona linha Nome do Investimento
        row.push(<div key={`table-legenda-${coluna}`} className={style.columnName}>
          <div>{acumulado[coluna].investimentType}</div>
          {(window.screen.width > 768)?<div>&nbsp;/&nbsp;</div>:''}
          <div>{acumulado[coluna].rentability}</div>
        </div>)
        // Adiciona linha de valor Rendimento
        row.push(<div key={`table-rendimento-${coluna}`} className={style.tableData}>{formatCurrency(((acumulado[coluna].value - investido)/investido)*100)}%</div>)
        // Adiciona linha de Juros
        row.push(<div key={`table-juros-${coluna}`} className={`${style.tableDataBold} ${style.tableDataWhite}`}>{formatCurrency(acumulado[coluna].value - investido)}</div>)
        // Adiciona linha de Alíq. Imposto
        row.push(<div key={`table-aliq-imposto-${coluna}`} className={style.tableData}>{formatCurrency(acumulado[coluna].alImposto)}%</div>)
        // Adiciona linha de Desc. Imposto
        row.push(<div key={`table-desc-imposto-${coluna}`} className={style.tableData}>{formatCurrency((acumulado[coluna].value - investido)*(acumulado[coluna].alImposto/100))}</div>)
        if(props.type === 'real'){
          // Adiciona linha de Inflação
          row.push(<div key={`table-inflacao-${coluna}`} className={style.tableData}>{formatCurrency(acumulado[coluna].inflacao)}%</div>)
          // Adiciona linha de Rentabilidade Real
          row.push(<div key={`table-rentabilidade-${coluna}`} className={style.tableDataBold}>{formatCurrency(calcularRentabilidadeReal(((acumulado[coluna].value - investido)/investido), acumulado[coluna].inflacao/100))}%</div>)
        }
        columns.push(<div key={`table-coluna-${coluna}`} style={{flex: 1}}>{row}</div>)
      }
      table.push(
        <div key={'table'} className={style.table}>
          <div className={style.rowLegend}>
            <div className={style.columnNameNoBorder}><div>&nbsp;</div><div>&nbsp;</div></div>
            <div className={style.tableColumn}>Rendimento</div>
            <div className={`${style.tableColumnBold} ${style.tableDataWhite}`}>Juros (R$)</div>
            <div className={style.tableColumn}>Alíq. Imposto</div>
            <div className={style.tableColumn}>{(window.screen.width <= 768)?'Desc. Imp.':'Desc. Imposto (R$)'}</div>
            {(props.type === 'real')?<div className={style.tableColumn}>Inflação</div>:null}
            {(props.type === 'real')?<div className={style.tableColumnBold}>
              Rent. Real
              <Label tooltip={true} tooltipText={'A rentabilidade real desconta a inflação.'} autosize={true} whiteMode={true} />
            </div>:null}
          </div>
          <div className={style.tableColumns}>{columns}</div>
        </div>
      )
      return table
    }

    return (
        <div className={style.main}>
            {criaTabela()}
        </div>
    )
}
